import React, { useContext } from 'react';
import { ChartWrapper, Main } from 'Benchmarks/Benchmarks.styles';
import {
	AnalysisWrapper,
	TableCellChart,
	TableCellGroup,
	TableCellMin,
	TableContainer,
	TableHead,
	TableRow,
	TableBody,
	AnalysisWrapper2,
} from 'Benchmarks/components/BenchmarkContainer/BenchmarkContainer.styles';

import ProcurementFilters from '../ProcurementFilters/ProcurementFilters';
import { procurementMetricsContext } from '../Context/ProcurementMetricsContextProvider';
import TableRowsWithSelectedOptions from '../Components/TableRowsWithSelectedOptions/TableRowsWithSelectedOptions';
import { ApLoaderDefault } from '@alixpartners/ui-components';

const ProcurementMetricsCategorical = () => {
	const { tab2Data, loadingTab2 } = useContext(procurementMetricsContext);
	return (
		<Main>
			<ChartWrapper loadingTab2={loadingTab2}>
				<ProcurementFilters />
				<AnalysisWrapper2
					index="0"
					loadingTab2={loadingTab2}
					tab2Data={tab2Data}
				>
					<div
						style={{
							width: '100%',
							textAlign: 'center',
							marginTop: '1rem',
							fontWeight: 'bold',
						}}
					>
						Reference Performace Range ({' '}
						<div
							style={{
								height: '15px',
								width: '15px',
								backgroundColor: '#5cb335',
								display: 'inline-block',
								position: 'relative',
								top: '2px',
								marginLeft: '5px',
								marginRight: '5px',
							}}
						/>
						- Green boxes indicate your selection )
					</div>
					{loadingTab2 ? (
						<div
							style={{
								verticalAlign: 'middle',
								minHeight: '60rem',
								borderBottom: '1px solid #d4d4d4',
								marginTop: '9rem',
								width: '100%',
							}}
						>
							<ApLoaderDefault />
						</div>
					) : (
						<>
							{tab2Data.length > 0 &&
								tab2Data.map((item, index) => {
									return (
										<TableRowsWithSelectedOptions
											key={index}
											name={item.name}
											metricsData={item.data}
											index={index}
										/>
									);
								})}
						</>
					)}
				</AnalysisWrapper2>
			</ChartWrapper>
		</Main>
	);
};

export default ProcurementMetricsCategorical;
